var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _g, _path8, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertPlanJoinWaitlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m475.88 429.46s-296.71 376.65 232.77 363.15l21 18v-126.38l-181.42-40.11 21.3-232.49",
    fill: "#ea5e94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m554.57 574.86c-54.78 2.87-98.64 75.93-98.64 165.64 0 2 0 3.93.07 5.88 40.39 26 103.57 43.48 198.77 46.21a261.27 261.27 0 0 0 5.15-52.09 253 253 0 0 0 -10.73-74.06l-101-22.32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m502.56 436s-20.19 329.5 36.83 485.5l-11.91 17.5h101.41s11.11-419.09 11.11-509.54z",
    fill: "#ff6498"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m579.61 181.09v42.82l-53.04 13.03v-72.26l53.04-13.03z",
    fill: "#edeeef"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 549.65,
    cy: 194.48,
    r: 1.42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 571.43,
    cy: 194.48,
    r: 1.42
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m565.04 202.94v-21.85h10.95",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m546.97 181.09h10.95",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m530.06 192.29v7.59a7.41 7.41 0 0 1 -7.41-7.42c0-.23 0-.45 0-.67.44-4.61 7.41-4.13 7.41.5z",
    fill: "#edeeef"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m530.06 199.88a7.41 7.41 0 0 1 -7.41-7.42",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560.25 208.33a7.5 7.5 0 0 1 -7.5-7.5",
    stroke: "#ff6498"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m579.61 223.91-53.04 13.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m565.04 202.96-4.79 1.18",
    strokeLinecap: "round"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m475.88 313.62v115.84l164.12 40.33v-129a99.38 99.38 0 0 0 -75.65-96.5 71.4 71.4 0 0 0 -88.44 69.34z",
    fill: "#edeeef"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m502.56 436s-20.19 329.5 36.83 485.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m524.8 188.84s-7.13-23.62 4.12-33.37 61-7.25 61-7.25 3.5 34.5-47.75 26.25c0 0-.75 9.56-9.25 11.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m595.51 258s74.82 48 60.82 178-205.33-34.62-210.66-46.62 14.66-22 39.33-8c0 0-10-8.39-5.33-9.53s14.18 2.2 19.42 12.87l115.91 21.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.21 374.22h-115.54l-50.67-117.14"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m320.09 269.72 179-97",
    stroke: "#ff6498"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m497.94 262s-41 38.71-53.14 112.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.67 374.22s29.33 83.16 63.43 91.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.67 374.22s-14.48-20.17-24.08-24.84-38.59 6-34.92 11 10.33 2.34 10.33 2.34-1.67 5 1.33 6.33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertPlanJoinWaitlist);
export default __webpack_public_path__ + "static/media/convert-plan-join-waitlist.afe3dc8104cd0be49de1731a1057a1a9.svg";
export { ForwardRef as ReactComponent };